module.exports = __webpack_public_path__ + "img/send_bot.3333940c.svg";